<template>
  <section>
    <h2>{{ $t('src/pages/settings.496') }}</h2>
    <base-spinner v-if="loading"></base-spinner>
    <div v-else-if="noSettings">{{ $t('src/pages/settings.2636') }}</div>
    <div v-else class="form-limited-width">
      <div class="form-group">
        <label class="form-label text-muted">{{ $t('src/pages/settings.5544') }}</label>
        <input
          type="text"
          name="server-name"
          class="form-control"
          :class="{ 'is-invalid': $v.settings.server_name.$invalid }"
          v-model="settings.server_name"
          @blur="$v.settings.server_name.$touch()"
        />
      </div>
      <div class="form-group">
        <label class="form-label text-muted">{{ $t('src/pages/settings.8551') }}</label>
        <div class="form-check-inline mt-1">
          <div v-for="(name, key) in ecgStorage" :key="key" class="custom-control custom-radio">
            <input
              type="radio"
              class="custom-control-input"
              :id="`method-${key}`"
              :value="key"
              v-model="settings.storage_method"
            />
            <label :for="`method-${key}`" class="custom-control-label">{{ name }}</label>
          </div>
        </div>
      </div>
      <button type="button" class="btn btn-dark mt-3" @click="submit">
        <span v-if="saving" class="spinner-border spinner-border-sm"></span>{{ $t('button.save') }}
      </button>
    </div>
  </section>
</template>

<script>
import http from '@/modules/http.js'
import { serverSettings } from '@/main.config.js'
import { required } from 'vuelidate/lib/validators'
import { savedMessage } from '@/mixins/saved-message.js'

export default {
  name: 'SettingsServer',
  mixins: [savedMessage],
  components: {
    BaseSpinner: () => import('@/base/BaseSpinner.vue')
  },
  data: () => ({
    settings: null,
    loading: true,
    saving: false
  }),
  validations() {
    return {
      settings: {
        server_name: {
          required
        }
      }
    }
  },
  mounted() {
    this.loadData()
  },
  computed: {
    noSettings() {
      return !!this.settings && this.settings.length
    },
    ecgStorage() {
      return serverSettings.ecgStorage
    }
  },
  methods: {
    loadData() {
      http
        .get('/settings')
        .then(response => {
          this.settings = response.data
        })
        .catch(error => console.error(error))
        .finally(() => (this.loading = false))
    },
    submit() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.patchData()
        this.$v.$reset()
      }
    },
    patchData() {
      this.saving = true
      http
        .patch('/settings', this.settings)
        .then(() => {
          this.$emit('saved:data')
        })
        .catch(error => {
          console.error(error)
        })
        .finally(() => {
          this.saving = false
        })
    }
  }
}
</script>
